// Reveals the fixed bottom CTA bar once the user has scrolled past the hero.
// Vanilla JS only — no React/TS. The element ships hidden (translate-y-full)
// and is slid into view by toggling Tailwind translate utilities.
const StickyCta = {
  mounted() {
    this.threshold = parseInt(this.el.dataset.revealAfter || '560', 10)

    this.onScroll = () => {
      const show = (window.scrollY || window.pageYOffset || 0) > this.threshold
      this.el.classList.toggle('translate-y-0', show)
      this.el.classList.toggle('translate-y-full', !show)
    }

    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
}

export default StickyCta
